<mat-card>
  <app-card-header
    [title]="titulo"
    icono="description"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="preview-content">
      @if (loading && !iframeUrl) {
        <div class="loading-wrap">
          <mat-spinner diameter="48" color="primary" />
        </div>
      }

      @if (iframeUrl) {
        <!-- Ver SANDBOX_INFORME en el componente -->
        <iframe
          [src]="iframeUrl"
          class="preview-iframe"
          title="Informe de alerta"
          sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    @if (tieneAudio) {
      <button
        irxBoton="secundario"
        type="button"
        (click)="descargarAudio()"
        [disabled]="loading"
      >
        @if (loading) {
          <mat-spinner diameter="18" color="primary" />
        } @else {
          <mat-icon>audiotrack</mat-icon>
        }
        Descargar audio
      </button>
    }
    <button
      irxBoton="secundario"
      type="button"
      (click)="verInformeEnPestania()"
      [disabled]="!iframeUrl || loading"
    >
      <mat-icon>open_in_new</mat-icon>
      Abrir en pestaña
    </button>
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
